import React, { FC, useState } from "react"
import styled from "styled-components"
import { SearchIcon } from "ui-kit-sber/dist/js/components/Icons"
import closeIcon from "../../../static/icons/close_popup.svg"

const SearchStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 32px;
`

const SearchIconStyle = styled.a`
  cursor: pointer;
`

const SearchFormStyle = styled.div`
  padding-left: 28px;
  display: flex;
  width: 400px;
  overflow: hidden;
  justify-content: flex-end;

  input {
    width: stretch;
    border: none;
    font-size: 13px;

    &:focus {
      outline: none;
    }
  }
`

const SearchFormClose = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 21px;
    cursor: pointer;
  }
`

interface ISearchForm {
  onClose: () => void
}

export const SearchForm: FC<ISearchForm> = ({ onClose }) => {
  const [search, setSearch] = useState<string>("")

  const openSearchPage = event => {
    if (event.keyCode === 13) {
      const win = window.open(
        `http://npfsberbanka.ru/search/?q=${search}`,
        "_top"
      )
    }
  }

  return (
    <SearchStyle>
      <SearchIconStyle href={`http://npfsberbanka.ru/search/?q=${search}`}>
        <SearchIcon />
      </SearchIconStyle>
      <SearchFormStyle>
        <input
          name="q"
          type="text"
          placeholder="Поиск по сайту"
          value={search}
          onChange={({ target }) => setSearch(target.value)}
          onKeyDown={openSearchPage}
        />
        <SearchFormClose onClick={onClose}>
          <img src={closeIcon} />
        </SearchFormClose>
      </SearchFormStyle>
    </SearchStyle>
  )
}
